export const LOGO_HOME = 'logotipo-muviflex.png'
export const BRAND_NAME = 'Muviflex'
export const ADRESS =
	'Rua Dona Teodora, 503 - Farrapos - Porto Alegre/RS CEP: 90.240-300'
export const COMPANY_NAME =
	'Movimento e Flexibilidade Desenvolvimento e Gerenciamento de Programa de Fidelização de Clientes Ltda. - CNPJ: 30.715.948/0001-94'
export const EMAIL = 'faleconosco@muviflex.com.br'
export const RATING_SITE_URL = 'https://www.reclameaqui.com.br/empresa/muviflex'
export const CHIPEST =
	'Sua viagem muito mais acessível. Aqui você encontrará a menor taxa do mercado e garantia do melhor preço. Explore novos destinos economizando!'
export const IS_DIGITAL =
	'Garantimos a melhor experiência de compra! Simplificamos a sua viagem desde a sua compra até o embarque. Apresente a passagem pelo celular no embarque!'
export const RELIBLE =
	'Nossa reputação inspira confiança. Ofertamos viagens de viações renomadas no mercado e devidamente regulamentadas.'
export const TRAVEL =
	'A cada viagem, exclusivamente da Planalto, você ganha pontos Muviflex que valem descontos, passagens grátis e muito mais!'
export const EASY_PURCHASE =
	'Pague com Cartão de crédito, Pix, Muvicard ou Pontos, a depender da regra da viação. Aqui você também encontra um atendimento excepcional!'
export const LOGO_LOADING = 'loading-logo-muviflex.png'
export const URL_HOME = 'muviflex.com.br'
export const GOOGLE_ANALYTICS = 'G-M12RZJV9E5'
export const GOOGLE_GLOBAL = 'AW-759053082'
export const GOOGLE_CONVERTION = `${GOOGLE_GLOBAL}/92v5CLrW8L4YEJr2-OkC`
export const TOKEN_HANDTALK = 'b49d4b88f0556bf283620506df65feb5'
export const META_PIXEL = '472214079224607'
export const TIKTOK_PIXEL = 'Ainda não temos'
